import styles from './GuessCardView.module.scss'
import classNames from 'classnames'
import { ScryfallCard } from "@scryfall/api-types";
import Button from "@/components/UI/Button/Button";
import {useEffect} from "react";

type Props = {
  isGuessing: boolean
  card: ScryfallCard.Normal
  guesses?: string[]
  guessIndex: number
  setGuessIndex: (index: number) => void
  currentGuess: string[]
  onGuess: () => void
  notifyingWrongGuess: boolean
  cardGuesses: string[][]
}

const GuessCardView = ({isGuessing, card, guesses, guessIndex, currentGuess, onGuess, notifyingWrongGuess, setGuessIndex}: Props) => {

  let currentGuessIndex = 0

  return (
    <div className={classNames(styles.overlay, !isGuessing && styles.noDisplay)}>
      <div className={styles.innerContainer}>
        {card.name.split(' ').map((word, i) => (
          <div key={i} className={classNames(styles.word, notifyingWrongGuess && styles.wrong)}>
            {word.split('').map((letter, j) => {
              const isSpecial = !letter.toLowerCase().match(/^[0-9a-z]+$/)
              const isGuessed = guesses?.includes(letter)
              const guess = !isSpecial && currentGuess[currentGuessIndex]
              const cur = currentGuessIndex
              if (!isSpecial) currentGuessIndex++

              return (
                <div
                  key={j}
                  onClick={() => {
                    if (!isSpecial) setGuessIndex(cur)
                  }}
                  className={classNames(
                    styles.letter,
                    isSpecial && styles.special,
                    (!isGuessed && !isSpecial) && styles.notGuessed,
                    guess && styles.guess,
                    cur === guessIndex && !isSpecial && styles.cursor,
                  )}
                >
                  {guess ? guess : isGuessed || isSpecial ? letter.toUpperCase() : '_'}
                </div>
            )})}
          </div>
        ))}
      </div>
      <Button
        disabled={currentGuess.filter(letter => letter).length !== card.name.toLowerCase().replace(/[^0-9a-z]/gi, '').length }
        className={styles.guessButton}
        onClick={onGuess}
      >
        Guess
      </Button>

    </div>
  )
}

export default GuessCardView